/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { BcsFlag, FcsFlag } from "../unleash";

const BULK_BOOKING_FLAG_NAMESPACE = "featureBulkBooking";

const FcsPermissionBulkBookingV2 = {
  feature_bulk_booking_internal_v2: new FcsFlag.Flag(false)
};

const RoxPermissionBulkBookingV2 = {
  feature_bulk_booking_v2: new Rox.Flag(true),
};

const BcsPermissionBulkBookingV2 = {
  config_bulk_booking_v2_max_stt: new BcsFlag.NumberFlag(
    500,
    `${BULK_BOOKING_FLAG_NAMESPACE}.config_bulk_booking_v2_max_stt`
  ),
  config_bulk_booking_v2_max_file_MB: new BcsFlag.NumberFlag(
    5,
    `${BULK_BOOKING_FLAG_NAMESPACE}.config_bulk_booking_v2_max_file_MB`
  )
};

export const FlagsPermissionBulkBookingV2 = {
  ...FcsPermissionBulkBookingV2,
  ...RoxPermissionBulkBookingV2,
  ...BcsPermissionBulkBookingV2
};

export function initFlagsPermissionBulkBookingV2() {
  // register flags with namespaces for better grouping
  Rox.register(BULK_BOOKING_FLAG_NAMESPACE, RoxPermissionBulkBookingV2);
  FcsFlag.register(BULK_BOOKING_FLAG_NAMESPACE, FcsPermissionBulkBookingV2);
  BcsFlag.register(BULK_BOOKING_FLAG_NAMESPACE, BcsPermissionBulkBookingV2);
}
